<script>
import Layout from "@/views/layouts/default";
import appConfig from "@/app.config";
import moment from "moment";

export default {
  page: {
    title: "Notifikasi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      title: "Notifikasi",
      items: [
        {
          text: "",
        },
      ],
      notifications: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
    };
  },
  watch: {
    currentPage() {
      this.getData();
    },
  },
  methods: {
    async redirectLink(i) {
      await this.$axios.get(`/v1/notification/${i.id}`).then(response => console.log(response.data))
      this.$store.dispatch('getNotification')
      const indexNotif = this.notifications.findIndex(item => item.id === i.id)
      if (indexNotif >= 0) {
        this.notifications[indexNotif].read_at = moment().format('YYYY-MM-DD')
      }
      if (i.data.type === 'registration_lc') {
        window.open(`/profile-update`, '_blank')
      } else if (i.data.type === 'profile') {
        window.open(`/profile`, '_blank')
      } else {
        window.open(`/job/${i.data.id}`, '_blank')
      }
    },
    getData() {
      this.$axios.get('/v1/notification', {
        params: {
          page: this.currentPage,
          per_page: this.perPage,
          orderby: 'created_at',
          sort: 'desc',
        }
      })
        .then(response => {
          this.notifications = response.data.data.rows
          this.totalRows = response.data.data.total_data
        })
    },
  },
  mounted() {
    this.getData();
  },
};
</script>

<template>
  <Layout>
    <!-- start page title -->
    <div class="row align-items-center">
      <div class="col-sm-6">
        <div class="page-title-box">
          <h4 class="font-size-18">Notifikasi</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- /.modal -->
            <div class="list-job mx-2 my-3">
              <div
                class="row border border-danger rounded py-1 mb-2"
                v-for="(i, index) in notifications"
                :key="index"
                @click="redirectLink(i)"
                style="cursor: pointer"
                :class="{ unread: i.read_at === null }"
              >
                <div class="col-sm-12 py-2">
                  <div class="row">
                    <div class="col-md-10">
                      <h5>{{ i.subject | capitalize }}</h5>
                    </div>
                    <div class="col-md-2">
                      <p class="font-size-11 font-weight-bolder float-right">
                        {{ i.created_at | date_time }}
                      </p>
                    </div>
                  </div>
                  <h6>{{ i.body }}</h6>
                </div>
              </div>
            </div>
          </div>

          <div class="row mb-3" v-if="notifications.length > 0">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>


<style scoped>
.unread {
  background-color: #e9ecef !important
}
</style>